import DataConst from 'consts/DataConst';

export default {
  name: DataConst.MODELS.ORDER,
  primaryKey: 'id',
  properties: {
    id: 'int',
    customer: 'Customer',
    orderItems: 'OrderItem[]',
    surcharge: 'int?',
    note: 'string?',
    money: 'double',
    moneyDiscount: { type: 'double', default: 0 },
    paid: 'double',
    status: 'int',
    createdAt: 'date',
    updatedAt: 'date?'
  }
};
